// Verde Capital analytics: GA4 loads only when REACT_APP_GA4_ID is set in frontend/.env.
// dataLayer pushes always happen so Meta/other pixels can consume them later.

const GA4_ID = process.env.REACT_APP_GA4_ID || "";

import { measurePageView } from "./openaiPixel";

export function initAnalytics() {
  if (window.__vcAnalyticsReady) return;
  window.__vcAnalyticsReady = true;
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
  if (GA4_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(s);
    window.gtag("js", new Date());
    window.gtag("config", GA4_ID, { send_page_view: false });
  }
}

export function trackPageView(path) {
  initAnalytics();
  window.gtag("event", "page_view", { page_path: path });
  measurePageView(path);
}

export function trackEvent(name, params = {}) {
  initAnalytics();
  window.gtag("event", name, params);
  window.dataLayer.push({ event: name, ...params });
}

// UTM/CLICK ids from the current URL, e.g. utm_source/utm_medium/utm_campaign/utm_content/gclid/fbclid
export function campaignAttribution(search) {
  const p = new URLSearchParams(search || window.location.search);
  const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "fbclid"];
  const found = keys.filter((k) => p.get(k)).map((k) => `${k}=${p.get(k)}`);
  return found.join(" | ");
}